export const VALET_LISTING_PAGE = 'VALET_LISTING_PAGE';
export const VALET_INCENTIVE_LIST = "VALET_INCENTIVE_LIST";
export const VALET_INCENTIVE_FILTER = "VALET_INCENTIVE_FILTER";
export const EDIT_INCENTIVE_DATA = "EDIT_INCENTIVE_DATA";
export const LAST_FIVE_TRANSACTIONS = "LAST_FIVE_TRANSACTIONS";
export const VALET_BULK_APPROVAL="VALET_BULK_APPROVAL";